import React, { useEffect, useRef } from "react";
import { useState } from "react";
import ColorPicker from "react-best-gradient-color-picker";

import { faPencil, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch, useSelector } from "react-redux";
import { HtmlFeature } from "../../../../slice/Features/Html";
import { currentFeature } from "../../../../slice/features";

import axios from "axios";
import { toast } from "react-toastify";
import lang from "../../../../assets/lang/icons.json";
import BodyLoading from "../../Loading/BodyLoading";
import Pro from "../../Pro/Pro";
import style from "./html.module.css";

const Html = () => {
  const dispatch = useDispatch();
  const isAuth = localStorage.getItem("auth_token") ? true : false;

  const [bodyLoading, setBodyLoading] = useState(false);

  const [Text, setText] = useState();

  const CancelFeature = (e) => {
    e.preventDefault();
    dispatch(currentFeature(""));
  };

  const handleText = (e) => {
    e.preventDefault();

    setText(e.target.value);
  };

  const saveFeature = async (e) => {
    e.preventDefault();
    dispatch(currentFeature(""));
    try {
      const data = {
        Text: Text,
      };

      const response = await axios.post("/add/html-feature", data);
      if (response.data.status === 200) {
        console.log(response.data);
        toast.success(response.data.message, {
          closeOnClick: true,
          theme: "colored",
        });
      } else {
        console.log(response.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetch = async () => {
    try {
      const response = await axios.get("/getUser");
      const user = await response.data.user;

      if (user.html_id !== null) {
        dispatch(HtmlFeature(user.html.text));

        setText(user.html.text);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    dispatch(HtmlFeature(Text));
  }, [Text, dispatch, isAuth]);

  useEffect(() => {
    if (isAuth) {
      fetch();
    }
  }, [isAuth]);

  return (
    <div className={`text-start `}>
      <h6>Use Custom HTML</h6>
      {bodyLoading ? <BodyLoading /> : null}
      <div className="" style={{ minHeight: "650px" }}>
        <div className={`${style.Form}`}>
          <span className="w-100 custom-header">Enter Your Custom HTML</span>
          <textarea
            value={Text}
            rows={5}
            className="form-control my-2"
            placeholder="Enter Your HTML Here"
            onChange={handleText}
          ></textarea>
        </div>
      </div>
      <div className="my-3">
        <button className={`btn btn-primary me-2 `} onClick={saveFeature}>
          save
        </button>
        <button className="btn btn-outline-secondary" onClick={CancelFeature}>
          Cancel
        </button>
      </div>
    </div>
  );
};
export default Html;
